import React, { ReactElement, InputHTMLAttributes } from 'react';
import { DataCollectionValuesKey } from '../../../hooks';
import FormControl from '../../FormControl';

interface InputCardProps {
    title: string;
    subtitle?: string | ReactElement;
    name: DataCollectionValuesKey;
    id: string;
    label?: string;
    type: string;
    value: string;
    unit?: string | ReactElement;
    error?: string | boolean | undefined;
    props?: InputHTMLAttributes<HTMLInputElement | HTMLSelectElement>;
    className?: string;
    handleChange: React.ChangeEventHandler<HTMLInputElement>;
    handleBlur: React.FocusEventHandler<HTMLInputElement | HTMLSelectElement>;
    min?: number;
    max?: number;
}

const InputCard = ({
    title,
    subtitle,
    id,
    name,
    type,
    label,
    unit,
    value,
    className,
    handleChange,
    handleBlur,
    min,
    max,
    ...props
}: InputCardProps): ReactElement<'div'> | null => {
    const validationStateClass = !props.error && value >= '1' ? 'wiz-input-card--success' : 'wiz-input-card--error';
    const validationClass = value != '' && value != '0' ? validationStateClass : '';
    const customClass = className || '';
    const containerClass = ['wiz-input-card', validationClass, customClass].join(' ');
    return (
        <div className={containerClass}>
            <div className={'wiz-input-card__body'}>
                <div>
                    <div className="wiz-input-card__title">{title}</div>
                    {subtitle && <div className="wiz-input-card__subtitle">{subtitle}</div>}
                </div>
                <div className={'wiz-input-card__input'}>
                    {label && <div className="wiz-input-card__label">{label}</div>}
                    <div className="wiz-form-container">
                        <input
                            className="wiz-form-control"
                            name={name}
                            id={id}
                            type={type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={value}
                            min={min || (type === 'number' ? 0 : '')}
                            max={max}
                            {...props}
                        />
                        {unit && <div className="wiz-form-text">{unit}</div>}
                    </div>
                    <div className={'wiz-input-card__check'}>
                        <img src="/img/icon/check-circle.svg" alt="checked" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InputCard;
